import axios from 'axios'
import store from '../../store/index'

const state = {
  appSettings: {},
}

const mutations = {
  appSettings_data (state, appSettings) {
    state.appSettings = appSettings
  },
}

const actions = {
  postAppSettings ({ commit }, appSettings) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/appSettings',
        data: appSettings,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('appSettings_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getAppSettings ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/appSettings',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('appSettings_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
